import {useCallback, useRef, useState} from "react";

export const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  // Hold the latest value in a ref so the setter can be a stable callback
  // (identity-stable across renders) while still reading the freshest value
  // for functional updates like setValue(prev => !prev).
  const latest = useRef(storedValue);
  latest.current = storedValue;

  const setValue = useCallback(
    value => {
      try {
        const valueToStore =
          value instanceof Function ? value(latest.current) : value;
        setStoredValue(valueToStore);
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      } catch (error) {
        console.log(error);
      }
    },
    [key]
  );

  return [storedValue, setValue];
};
